import * as React from "react"; // tslint:disable-line
import styled from "styled-components";

import { theme } from "./theme";

const iconContent = {
  "360-player": "\\e962",
  office: "\\e038",
  iphone: "\\e03c",
  ipad: "\\e03d",
  mappin: "\\e05c",
  tick: "\\e06d",
  cross: "\\e607",
  reload: "\\e616",
  bed: "\\e61a",
  bath: "\\e61b",
  car: "\\e61c",
  "star-hollow": "\\e61d",
  star: "\\e61e",
  "multi-device": "\\e624",
  desktop: "\\e625",
  "info-sign": "\\e62d",
  "warning-sign": "\\e62e",
  reports: "\\e630",
  close: "\\e633",
  clockcircleo: "\\e641",
  bulb: "\\e649",
  staro: "\\e661",
  sharealt: "\\e671",
  picture: "\\e674",
  camerao: "\\e68a",
  delete: "\\e69f",
  pdffile: "\\e6b3",
  idcard: "\\e6e5",
  bank: "\\e6ee",
  "star-mellow-success": "\\e900",
  "star-mellow": "\\e901",
  "add-lg": "\\e902",
  "success-lg": "\\e903",
  "success-bold": "\\e992",
  watermark: "\\e904",
  allocation: "\\e905",
  switch: "\\e906",
  allocate: "\\e907",
  members: "\\e908",
  other: "\\e909",
  add: "\\e90a",
  subtract: "\\e90b",
  move: "\\e90c",
  quality: "\\e90d",
  upwards: "\\e90e",
  setting: "\\e90f",
  "line-chart": "\\e910",
  copy: "\\e911",
  "log-out": "\\e912",
  inactive: "\\e913",
  wechat: "\\e914",
  remove: "\\e915",
  success: "\\e916",
  empty: "\\e917",
  more: "\\e918",
  "image-quality": "\\e919",
  fsbo: "\\e91a",
  "copy-new": "\\e91b",
  megaphone: "\\e91c",
  enquiries: "\\e91d",
  "share-lg": "\\e91e",
  impressions: "\\e91f",
  eye: "\\e920",
  listings: "\\e921",
  pageviews: "\\e922",
  "warning-lg": "\\e923",
  "link-lg": "\\e924",
  "linkedin-square": "\\e925",
  "facebook-square": "\\e926",
  "external-link-lg": "\\e927",
  "user-md": "\\e928",
  accountSettings: "\\e929",
  "air-conditioner": "\\e92a",
  balcony: "\\e92b",
  "bath-tub": "\\e92c",
  "kitchen-cabinet": "\\e92d",
  garage: "\\e92e",
  garden: "\\e92f",
  "badminton-court": "\\e930",
  "basketball-court": "\\e931",
  bbq: "\\e932",
  "business-centre": "\\e933",
  cafeteria: "\\e934",
  "360": "\\e935",
  search: "\\e936",
  "multi-user": "\\e937",
  "club-house": "\\e938",
  "check-on": "\\e939",
  "check-off": "\\e93a",
  "arrow-down": "\\e93b",
  "arrow-left": "\\e93c",
  "arrow-right": "\\e93d",
  "arrow-up": "\\e93e",
  "arrow-top": "\\e9a1",
  back: "\\e93f",
  forward: "\\e940",
  video: "\\e941",
  gymnasium: "\\e942",
  camera: "\\e943",
  "24-hours-security": "\\e944",
  jacuzzi: "\\e945",
  floorplan: "\\e946",
  "jogging-track": "\\e947",
  "mini-market": "\\e948",
  play: "\\e949",
  nursery: "\\e94a",
  parking: "\\e94b",
  "3d-tour": "\\e94c",
  playground: "\\e94d",
  listview: "\\e94e",
  salon: "\\e94f",
  filters: "\\e950",
  edit: "\\e951",
  sauna: "\\e952",
  bell: "\\e953",
  call: "\\e954",
  "shuttle-bus": "\\e955",
  "squash-court": "\\e956",
  email: "\\e957",
  "swimming-pool": "\\e958",
  "tennis-court": "\\e959",
  home: "\\e95a",
  "wading-pool": "\\e95b",
  allocations: "\\e95c",
  avatar: "\\e95d",
  question: "\\e95e",
  bounced: "\\e95f",
  delivered: "\\e960",
  quarantined: "\\e961",
  expand: "\\e965",
  minimise: "\\e966",
  "bell-round": "\\e96c",
  "bell-on": "\\e96d",
  "envelope-off": "\\e96e",
  "envelope-on": "\\e96f",
  sphere: "\\e9c9",
  link: "\\e9cb",
  crop: "\\ea57",
  share: "\\ea7d",
  "google-plus": "\\ea8d",
  facebook: "\\ea90",
  whatsapp: "\\ea93",
  twitter: "\\ea96",
  weibo: "\\ea9a",
  linkedin: "\\eaca",
  enquirySettings: "\\e963",
  myTeam: "\\e964",
  enquiryManagement: "\\e967",
  signOut: "\\e968",
  packages: "\\e969",
  userGuide: "\\e96a",
  "qc-dashboard": "\\e96b",
  event: "\\e970",
  promo: "\\e971",
  training: "\\e972",
  announcementUpdate: "\\e973",
  "default-avatar": "\\e974",
  listToggleIconMobile: "\\e995",
  cardToggleIconMobile: "\\e975",
  "autoupgrade-reload": "\\e976",
  "info-sign-italic": "\\e977",
  "default-avatar-lg": "\\e978",
  "info-sign-lg": "\\e979",
  "agent-net-icon": "\\e97a",
  "price-tag": "\\e97b",
  download: "\\e97c",
  "payment-history": "\\e97d",
  "tips-light-bulb": "\\e97e",
  fourclock: "\\e97f",
  "calendar-m": "\\e980",
  "up-circled": "\\e98b",
  "phone-o": "\\e988",
  "sms-o": "\\e989",
  "mail-o": "\\e98a",
  views: "\\e987",
  photo: "\\e986",
  money: "\\e985",
  maps: "\\e984",
  "info-o": "\\e981",
  "heart-o": "\\e983",
  "share-o": "\\e982",
  "money-i": "\\e98d",
  "listing-i": "\\e98c",
  "area-i": "\\e98f",
  "condo-i": "\\e98e",
  "location-b": "\\e991",
  location: "\\e990",
  "system-error": "\\e993",
  "unable-to-find": "\\e99a",
  "avatar-bold": "\\e994",
  "whatsapp-color": "\\e996",
  "circle-dot": "\\e997",
  "info-sign-bold": "\\e998",
  "whatsapp-o": "\\e999",
  "home-v2": "\\e99c",
  "building-large": "\\e99b",
  factory: "\\e99d",
  agricultural: "\\e99e",
  "table-filter": "\\e99f",
  "map-zoom-in": "\\e9a0",
};

export type IconTypes = keyof typeof iconContent;

export interface IconProps {
  type: IconTypes;
  size?: string;
  cursor?: string;
}
const Icon = styled.i<IconProps>`
  font-family: "rui-icon", sans-serif;
  font-style: normal;
  &:before {
    content: "${(props) => props.type && iconContent[props.type]}";
  }
  font-size: ${(props) => (props.size ? props.size : "1.6rem")};
  color: ${(props) => (props.color ? props.color : theme.gray)};

  ${({ cursor }) =>
    cursor &&
    `
    cursor: ${cursor};
  `}

  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
`;

export { Icon, iconContent };

export default Icon;
